import { isAllowedEffortLevel } from '@agentteams/core-constants';

// 러너 요청 Effort(추론 강도) 레벨의 사용자 노출 라벨 매핑.
// 동적 i18n 키 접근을 피하기 위해 레벨 → 키를 명시적으로 정의한다.
// 매핑에 없는 레벨(신규 추가 등)은 원문 값을 그대로 노출한다(안전망).
export const effortLevelLabelKeyByLevel: Record<string, string> = {
  minimal: 'daemonEffortMinimal',
  low: 'daemonEffortLow',
  medium: 'daemonEffortMedium',
  high: 'daemonEffortHigh',
  xhigh: 'daemonEffortXhigh',
  max: 'daemonEffortMax',
};

export const getEffortLevelLabel = (level: string, t: (key: string) => string): string => {
  const key = effortLevelLabelKeyByLevel[level];
  return key ? t(key) : level;
};

// 오래된 수동 메타데이터도 현재 엔진 계약과 교차해 실행 가능한 값만 노출한다.
export const getSupportedEffortLevels = (runnerType: string, levels?: readonly string[]): string[] =>
  (levels ?? []).filter((level) => isAllowedEffortLevel(runnerType, level));
